(ns frontend.ui.page.fund.event
  (:require
   [frontend.ui.page.lp-report-editor.event :as lp-report-editor-event]
   [re-frame.core :as rf]
   [frontend.controller.websocket.event :as ws]
   [frontend.routing :as routing]
   [frontend.ui.page.fund.model :as model]))

(defn lp-reports
  [db [_ request response]]
  (model/loaded db (assoc request :response response)))

(rf/reg-event-db ::lp-reports lp-reports)

(defn lp-reports-failed
  [db [_ request error]]
  (model/failed db (assoc request :error error)))

(rf/reg-event-db ::lp-reports-failed lp-reports-failed)

(rf/reg-event-fx
 ::lp-report-created
 (fn [_cofx [_ fund-id resp]]
   (let [report (:body resp)
         report-id (:db/id report)]
     (rf/dispatch [::lp-report-editor-event/reset-editor report-id fund-id])
     {::routing/old-routing {:path-args [:lp-portal/report-editor :fund-id fund-id :id
                                         report-id]}})))

(rf/reg-event-fx
 ::lp-report-create-failed
 (fn [_cofx [_ fund-id resp]]
   (js/console.log "Failed to create LP report " fund-id resp)))

(rf/reg-event-fx
 ::create-new-lp-report
 (fn [_cofx [_ fund-id]]
   (let [new-report {:entity/type    :entity.type/lp-report
                     :lp-report/fund fund-id}]
     {::ws/send {:id         :entity/create-entity
                 :body       new-report
                 :on-success [::lp-report-created fund-id]
                 :on-error   [::lp-report-create-failed fund-id]}})))

(rf/reg-event-db
 ::open-stop-reporting
 (fn [db [_ fund-id]]
   (model/open-stop-reporting db fund-id)))

(rf/reg-event-db
 ::close-stop-reporting
 (fn [db [_ fund-id]]
   (model/close-stop-reporting db fund-id)))

(rf/reg-event-db
 ::toggle-stop-reporting-confirmation
 (fn [db [_ args]]
   (model/toggle-stop-reporting-confirmation db args)))
